(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-active-offers"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
  const offers = document.querySelectorAll(".offer-payment-button");

  offers.forEach(button => {
    const code = button.dataset.code;
    const copyBtn = button.querySelector(".copy__code");
    const copied = button.querySelector(".copiedd");

    button.addEventListener("click", e => {
      e.preventDefault();
      e.stopPropagation();
    });

    copyBtn?.addEventListener("click", e => {
      e.preventDefault();
      e.stopPropagation();

      navigator.clipboard.writeText(code);

      copied.style.display = "inline-block";
      setTimeout(() => {
        copied.style.display = "none";
      }, 1500);
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
